/** Products: rename one, or merge two names for the same thing into one. */

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Notice } from "@/components/ui/Field";
import { SettingsHeader } from "@/features/settings/SettingsHeader";
import { CatalogRow } from "./CatalogRow";
import { mergeTargets, productsQuery, useMergeProducts, useRenameProduct } from "./queries";

export function ProductsPage() {
  const { t } = useTranslation();
  const products = useQuery(productsQuery);
  const rename = useRenameProduct();
  const merge = useMergeProducts();

  return (
    <section className="space-y-5">
      <SettingsHeader
        title={t("catalog.products.title")}
        description={t("catalog.products.subtitle")}
      />

      {products.isPending && <p className="text-stone-500">{t("common.loading")}</p>}
      {products.isError && <Notice tone="error">{t("settings.errors.loadFailed")}</Notice>}
      {products.data?.length === 0 && <Notice tone="info">{t("catalog.products.empty")}</Notice>}

      {products.data && products.data.length > 0 && (
        <ul className="divide-y divide-stone-200 overflow-hidden rounded-lg border border-stone-200 bg-white">
          {products.data.map((product) => (
            <CatalogRow
              key={product.id}
              item={product}
              title={product.name}
              detail={t("catalog.products.lines", { count: product.line_count })}
              targets={mergeTargets(products.data, product.id)}
              onRename={(name) => rename.mutateAsync({ id: product.id, name })}
              onMerge={(intoId) => merge.mutateAsync({ id: product.id, intoId })}
            />
          ))}
        </ul>
      )}
    </section>
  );
}
